module.exports = __webpack_public_path__ + "img/icon-eye-show.a11f3a3d.svg";